import React from "react";

const METHOD_LABELS = {
  password: ["Password", "Use your Clikkle password"],
  authenticator: ["Authenticator", "Time-based verification code"],
  passkey: ["Passkey", "Use a device passkey"],
  securityKey: ["Security key", "Use a hardware security key"],
  trustedDevice: ["Trusted device", "Approve from a recognized device"],
  emailCode: ["Email code", "Send a one-time code to your recovery email"],
  backupCode: ["Backup code", "Use a recovery code"],
};

export default function GatewaySecurityMethods({ capabilities, selected = "password", onSelect }) {
  const methods = capabilities?.methods || {};
  const visible = Object.entries(methods).filter(([, contract]) => contract?.available || contract?.enabled);

  return (
    <div className="gatewaySecurityMethods" role="radiogroup" aria-label="Verification methods">
      {visible.map(([method, contract]) => {
        const [title, description] = METHOD_LABELS[method] || [method, "Verification method"];
        const disabled = !contract.enabled;
        return (
          <button
            type="button"
            key={method}
            className={`gatewaySecurityMethod${selected === method ? " gatewaySecurityMethod--selected" : ""}`}
            role="radio"
            aria-checked={selected === method}
            disabled={disabled}
            onClick={() => !disabled && onSelect?.(method)}
          >
            <span className="gatewaySecurityMethod__icon" aria-hidden="true">◇</span>
            <span><strong>{title}</strong><small>{description}</small></span>
            <em>{disabled ? "Unavailable" : selected === method ? "Selected" : "Choose"}</em>
          </button>
        );
      })}
    </div>
  );
}
